<template>
	<div class="consents-subview">
		<div class="subview-segment">
			<it-link :to="createWarningLink" class="button-link button-link-bicon"><sym-icon name="add-comment"/> {{ env.msg('menu.addWarning') }}</it-link>
		</div>
		<div class="subview-segment">
			<crm-table ref="table" :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch, inject} from "vue";
import CrmTable from "@/vue/table/CrmTable.vue";
import {injectEnv} from "@fd/Environment.ts";
import {addContextParams, ContextKey, getIntValue, hasValue, injectContext} from "@t/fd/AppContext.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {readOnlyKey} from "@t/security/ObjectAccess.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));
const table = ref<InstanceType<typeof CrmTable> | null>(null);
const ro = inject(readOnlyKey);

/*const party = computed<number>(() => {
	if (sourceType.value === SrcType.PARTY) {
		let idValue = sourceId.value;
		return typeof idValue === "number" ? idValue : parseInt(idValue);
	}
	if (hasValue(ctx.value, ContextKey.PERSON)) return getIntValue(ctx.value, ContextKey.PERSON);
	if (hasValue(ctx.value, ContextKey.BRANCH)) return getIntValue(ctx.value, ContextKey.BRANCH);
	if (hasValue(ctx.value, ContextKey.CUSTOMER)) return getIntValue(ctx.value, ContextKey.CUSTOMER);
	return 0;
});*/

const createWarningLink = computed<string>(() => {
	let link = 'createWarning.do';
	link = env.net.urlParam(link, "customer", sourceId.value);
	return link;
});

function refreshTable() {
	if (table.value) table.value.refresh();
}

const restApi = computed<string>(() => {
	let ep = "api/warnings/agendaSubview";
	ep = env.net.urlParam(ep, "customerId", sourceId.value);
	return ep;
});

</script>